import Vue from 'vue';
import VueRouter from 'vue-router';
import MainLayout from '../layouts/Main.vue';
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
import Prep from '../views/Prep.vue';
import VotosEmitidos from '../views/VotosEmitidos.vue';
import VotoDispositivo from '../views/VotoDispositivo.vue';
import UsersDevice from '../views/UsersDevice.vue';
import Padron from '../views/Padron.vue';
import Planillas from '../views/Planillas.vue';

// import Results from '../views/Results';
// import ResultsDivision from '../views/ResultsDivision';
import Preview from '../views/Preview';

import Auditoria from '../views/Auditor/Auditoria.vue';
import Mesas from '../views/Funcionario/Mesas.vue';
import MesasPublic from '../views/Mesas.vue';
import store from '../store';
import {
    ADMIN_TYPE,
    SECRETARIA_TYPE,
    FUNCIONARIO_TYPE,
    SUBCOMISION_TYPE,
    HELPDESK_TYPE,
} from '@/helpers/roleTypes';

Vue.use(VueRouter);
import admin from './admin';
import _ from 'lodash';

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/admin',
        meta: { access: [ADMIN_TYPE, SECRETARIA_TYPE, HELPDESK_TYPE] },
        component: () => import('@views/Admin/Dashboard'),
        children: admin,
    },
    {
        path: '/',
        component: MainLayout,
        children: [
            {
                path: 'mesas',
                meta: {
                    access: [
                        ADMIN_TYPE,
                        SECRETARIA_TYPE,
                        SUBCOMISION_TYPE,
                        FUNCIONARIO_TYPE,
                    ],
                },
                name: 'Mesas',
                component: Mesas,
            },
            {
                path: '',
                name: 'home',
                component: Home,
            },
            {
                path: 'prep',
                name: 'prep',
                component: Prep,
                meta: { access: [ADMIN_TYPE, SECRETARIA_TYPE] },
            },

            // {
            //     path: 'resultados',
            //     name: 'resultados',
            //     component: ResultsDivision,
            //     meta: { access: [ADMIN_TYPE, SECRETARIA_TYPE] },
            // },
            {
                path: 'preview',
                name: 'preview',
                component: Preview,
                meta: { access: [ADMIN_TYPE, SECRETARIA_TYPE] },
            },
            {
                path: 'votos-emitidos',
                name: 'votos-emitidos',
                component: VotosEmitidos,
                meta: { access: [ADMIN_TYPE] },
            },
            {
                path: 'dispositivos',
                name: 'dispositivos',
                component: UsersDevice,
                meta: { access: [ADMIN_TYPE] },
            },
            {
                path: 'padron',
                name: 'padron',
                component: Padron,
                meta: { access: [ADMIN_TYPE, SECRETARIA_TYPE, HELPDESK_TYPE] },
            },
            {
                path: 'auditoria',
                name: 'auditoria',
                component: Auditoria,
            },
            {
                path: 'prep/planillas',
                name: 'planillas',
                component: Planillas,
                meta: { access: [ADMIN_TYPE, SECRETARIA_TYPE, HELPDESK_TYPE] },
            },
            {
                path: 'voto-por-dispositivo',
                name: 'voto-por-dispositivo',
                component: VotoDispositivo,
                meta: { access: [ADMIN_TYPE, SECRETARIA_TYPE] },
            },

            // {
            //     path: 'table-manager',
            //     name: 'table-manager',
            //     component: TableManager,
            // },
            // {
            //     path: 'audit',
            //     name: 'audit',
            //     component: Audit,
            // },
        ],
    },
    {
        path: '/public/mesas',
        name: 'publicMesas',
        component: MesasPublic,
    },
    {
        path: '*',
        redirect: '/login',
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    linkActiveClass: 'active', // active class for non-exact links.
    linkExactActiveClass: 'active', // active class for *exact* links.
});

router.beforeEach((to, from, next) => {
    const isAuthenticated = !!store.getters.token;
    const mode = _.get(store, 'getters.user.mode');

    if (to.name !== 'Login' && to.name !== 'publicMesas' && !isAuthenticated) {
        next({ name: 'Login' });
    } else if (to.name === 'Login' && isAuthenticated) {
        if (to.meta.access && to.meta.access.includes(mode)) {
            next();
        } else {
            switch (mode) {
                case ADMIN_TYPE:
                case SECRETARIA_TYPE:
                    return next('/admin');
                case HELPDESK_TYPE:
                    return next('/padron');
                case FUNCIONARIO_TYPE:
                case SUBCOMISION_TYPE:
                    return next('/mesas');
            }
        }
    } else {
        if (isAuthenticated) {
            if (to.name !== 'publicMesas') {
                if (to.meta.access && to.meta.access.includes(mode)) {
                    next();
                } else {
                    switch (mode) {
                        case ADMIN_TYPE:
                        case SECRETARIA_TYPE:
                            return next('/admin');
                        case HELPDESK_TYPE:
                            return next('/padron');
                        case FUNCIONARIO_TYPE:
                        case SUBCOMISION_TYPE:
                            return next('/mesas');
                    }
                }
            }
        }
        next();
    }
});

export default router;
